export default __webpack_public_path__ + "static/media/angular.5c91b03a.svg";